
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import CodeBoxDialog from "@/components/Partners/CodeBoxDialog.vue";
import { sendToCodeBox } from "@/lib/partners/codebox/codebox";
import { pipe } from "fp-ts/lib/function";
import { fold } from "fp-ts/lib/Either";
import NotificationLogger from "@/lib/notifications/notifications";
import NiceButton from "@/components/UI/NiceButton.vue";

@Component({
  components: { CodeBoxDialog, NiceButton }
})
export default class CodeBoxButtonForCodeEditor extends Vue {
  @Prop()
  value!: string | null;

  dialogOpen = false;

  updateDialogOpen(open: boolean) {
    this.dialogOpen = open;
  }

  get shouldShowButton() {
    return this.value && !this.value.includes("wpcb_run_snippet");
  }

  loading = false;

  async sendToCodeBox() {
    if (this.value) {
      this.loading = true;

      pipe(
        await sendToCodeBox(this.value),
        fold(
          () => {
            NotificationLogger.log.message("Code was not saved.");
          },
          response => {
            if (response.status === "success") {
              const newCode = `<?php\n\n\\BreakdanceWPCodeBox\\runSnippet(${response.data.snippetId});\n\n?>`;

              this.$emit("codeboxSnippetSaved", newCode);
            } else {
              this.updateDialogOpen(true);
            }
          }
        )
      );
      this.loading = false;
    }
  }
}
